import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faTrash } from "@fortawesome/free-solid-svg-icons";

import { PAGE_SIZE_OPTIONS } from "../../Constants/FieldOptions";
import { DateTime } from "luxon";
import { Link } from "react-router-dom";

function OrganizationList(props) {
  const {
    listData,
    setPageSize,
    pageSize,
    previousCursors,
    onPreviousClicked,
    onNextClicked,
    onDeleteOrganization,
  } = props;
  return (
    <div class="b-table">
      <div class="table-wrapper has-mobile-cards">
        <table class="table is-fullwidth is-striped is-hoverable is-fullwidth">
          <thead>
            <tr>
              <th> Organization Id </th>
              <th> Invite Code</th>
              <th> Organization Name </th>
              <th> Created At </th>
              <th> Employees</th>
              <th> </th>
            </tr>
          </thead>
          <tbody>
            {listData &&
              listData.map((datum, i) => (
                <tr key={i}>
                  <td data-label="Name">{datum.uniqueId}</td>
                  <td data-label="Name">{datum.inviteCode}</td>
                  <td data-label="Email">{datum.organizationName}</td>
                  <td data-label="Email">
                    {DateTime.fromSeconds(datum.createdAt).toLocaleString(
                      DateTime.DATETIME_MED
                    )}
                  </td>
                  <td data-label="Email">{datum.employeesCount}</td>

                  <td class="is-actions-cell" align="end">
                    <div class="buttons is-right ">
                      <Link
                        to={"/organization/details/" + datum.id}
                        class="button is-small is-primary"
                        type="button"
                      >
                        <FontAwesomeIcon className="mdi" icon={faEye} />
                        &nbsp;View
                      </Link>
                      <div
                        onClick={() => onDeleteOrganization(datum.id)}
                        className="button is-small"
                      >
                        <FontAwesomeIcon className="mdi" icon={faTrash} />
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>

        <div class="columns">
          <div class="column is-half">
            <span class="select">
              <select
                class={`input has-text-grey-light`}
                name="pageSize"
                onChange={(e) => setPageSize(parseInt(e.target.value))}
              >
                {PAGE_SIZE_OPTIONS.map(function (option, i) {
                  return (
                    <option
                      selected={pageSize === option.value}
                      value={option.value}
                    >
                      {option.label}
                    </option>
                  );
                })}
              </select>
            </span>
          </div>
          <div class="column is-half has-text-right">
            {previousCursors.length > 0 && (
              <button class="button" onClick={onPreviousClicked}>
                Previous
              </button>
            )}
            {listData.hasNextPage && (
              <>
                <button class="button" onClick={onNextClicked}>
                  Next
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrganizationList;
